import {alpha, darken, lighten} from '@mui/material/styles';

export const aeroGradients = {
   panel: (base: string) =>
      `linear-gradient(
      145deg,
      ${alpha(lighten(base, 0.05), 0.9)},
      ${alpha(darken(base, 0.18), 0.9)}
    )`,

   glowRadial: (color: string, opacity: number, pos: string) =>
      `radial-gradient(at ${pos}, ${alpha(color, opacity)} 0px, transparent 55%)`,
};
